<template>
  <div class="pay-refund">
    <div class="hd ly-card hidden">
      <div class="fl">
        <advanced-query @search="search" size="medium" />
      </div>
      <div class="fr">
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-input
          v-model="query"
          style="width: 230px"
          placeholder="班级/学员/预约号/操作员/身份证"
          class="m-r-15 m-l-15"
        ></el-input>
        <el-button @click="() => search()" type="primary">查询</el-button>
        <el-button @click="exportExcel">导出</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      ref="lyTable"
      class="ly-card"
    >
      <template v-slot:refund_number="row">
        <el-button type="text" size="mini" @click="openDetail(row)">{{ row.refund_number }}</el-button>
      </template>
      <template v-slot:refund_reason="row">
        <span>{{ handleText(row) }}</span>
        <el-button
          type="text"
          v-if="row.refund_reason && row.refund_reason.length > 20"
          size="mini"
          @click="openReasonDetail(row)"
          >查看</el-button
        >
      </template>
    </ly-table>
    <el-dialog title="退款详情" append-to-body :visible.sync="dialogVisible" width="600px">
      <table class="native-table" v-loading="loading">
        <tr>
          <th>收费项目</th>
          <th>缴费金额</th>
          <th>已退缴费金额</th>
          <th>本次退款金额</th>
        </tr>
        <tr>
          <td>学费</td>
          <td>{{ refundDetail.already_paid_fee.class_fee }}</td>
          <td>{{ refundDetail.already_refund_fee.class_fee }}</td>
          <td>{{ refundDetail.current_refund_fee.class_fee }}</td>
        </tr>
        <tr>
          <td>保险费</td>
          <td>{{ refundDetail.already_paid_fee.insurance }}</td>
          <td>{{ refundDetail.already_refund_fee.insurance }}</td>
          <td>{{ refundDetail.current_refund_fee.insurance }}</td>
        </tr>
        <tr>
          <td>伙食费</td>
          <td>{{ refundDetail.already_paid_fee.food_expenses }}</td>
          <td>{{ refundDetail.already_refund_fee.food_expenses }}</td>
          <td>{{ refundDetail.current_refund_fee.food_expenses }}</td>
        </tr>
        <tr>
          <td>材料费</td>
          <td>{{ refundDetail.already_paid_fee.material_fee }}</td>
          <td>{{ refundDetail.already_refund_fee.material_fee }}</td>
          <td>{{ refundDetail.current_refund_fee.material_fee }}</td>
        </tr>
        <tr>
          <td>托管费</td>
          <td>{{ refundDetail.already_paid_fee.hosting_fee }}</td>
          <td>{{ refundDetail.already_refund_fee.hosting_fee }}</td>
          <td>{{ refundDetail.current_refund_fee.hosting_fee }}</td>
        </tr>
        <tr>
          <td>陪读费</td>
          <td>{{ refundDetail.already_paid_fee.accompanying_fee }}</td>
          <td>{{ refundDetail.already_refund_fee.accompanying_fee }}</td>
          <td>{{ refundDetail.current_refund_fee.accompanying_fee }}</td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog, Input, DatePicker } from 'element-ui';
import LyTable from '@/components/LyTable';
import { refundPageTable } from '@/utils/tableHeader';
import { finance } from '@/api';
import AdvancedQuery from '@/components/AdvancedQuery';
import utils from '@/utils/utils';

export default {
  name: 'PayRefund',
  components: {
    ElDialog: Dialog,
    LyTable,
    ElInput: Input,
    AdvancedQuery,
    ElDatePicker: DatePicker
  },
  data() {
    return {
      tableHeader: [],
      searchFormData: {},
      tmpSearch: {},
      query: '',
      refund_status: -1,
      getTableData: finance.refundFeeList,
      dialogVisible: false,
      refundDetail: {
        already_refund_fee: {},
        already_paid_fee: {},
        current_refund_fee: {}
      },
      date: [],
      loading: false
    };
  },
  mounted() {
    finance.refundStatus().then(res => {
      if (res && res.data) {
        refundPageTable[refundPageTable.length - 1].headerSlot.select = res.data;
        this.tableHeader = refundPageTable;
      }
    });
    this.search();
  },
  computed: {
    term() {
      return this.$store.state.schoolYear.term;
    },
    year() {
      return this.$store.state.schoolYear.year;
    }
  },
  methods: {
    search(data) {
      if (data) {
        this.tmpSearch = data;
      }
      const temp = data || {};
      let refund_start_time;
      let refund_end_time;
      if (this.date && this.date.length) {
        [refund_start_time, refund_end_time] = this.date;
        temp.refund_start_time = refund_start_time;
        temp.refund_end_time = refund_end_time;
      }
      this.searchFormData = {
        ...this.tmpSearch,
        query: this.query,
        ...temp
      };
      this.$refs.lyTable.setData();
    },
    openDetail(row) {
      this.dialogVisible = true;
      this.loading = true;
      finance
        .refundApplyDetail({
          record_id: row.id
        })
        .then(res => {
          if (res) {
            this.loading = false;
            this.refundDetail = res.data;
          }
        });
    },
    openReasonDetail(row) {
      this.$alert(row.refund_reason, '信息');
    },
    exportExcel() {
      const params = { refund_status: this.$store.refund_status, ...this.searchFormData };
      if (params.year === -1) {
        delete params.year;
      }
      if (params.term === -1) {
        delete params.term;
      }
      finance
        .exportRefundDetail({ params })
        .then(data => {
          if (data) utils.downloadData(data, '退费列表', 'xls');
        });
    },
    handleText(row) {
      if (!row.refund_reason) return '无';
      if (row.refund_reason.length > 20) {
        return `${row.refund_reason.slice(0, 20)}...`;
      }
      return row.refund_reason;
    }
  }
};
</script>
